module.exports = __webpack_public_path__ + "img/noti2.48a92696.jpeg";